module.exports = {

    setBool: function (name, value) {
        localStorage.setItem(name, value ? 'true' : 'false')
    },

    getBool: function (name, defaultValue = false) {
        if (localStorage.getItem(name))
            return localStorage.getItem(name) === 'true'
        else
            return defaultValue;
    },

    getNumber: function (name, defaultValue = 0) {
        if (localStorage.getItem(name))
            return Number(localStorage.getItem(name));
        else
            return defaultValue;
    },

    setNumber: function (name, value) {
        localStorage.setItem(name, value.toString())
    },

    getString: function (name, defaultValue = "") {
        if (localStorage.getItem(name))
            return localStorage.getItem(name);
        else
            return defaultValue;
    },

    setString: function (name, value) {
        localStorage.setItem(name, value)
    },

    getJSON: function (name, defaultValue = []) {
        if (localStorage.getItem(name))
            return JSON.parse(localStorage.getItem(name));
        else
            return defaultValue;
    },

    setJSON: function (name, value) {
        localStorage.setItem(name, JSON.stringify(value))
    }

}
